import {Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {IPromotionsForProviderResponse} from 'types';
import ImageUI from 'ui/ImageUI';
import {SpacerUI} from 'ui/SpacerUI';

interface IProps {
  promotion: IPromotionsForProviderResponse;
  default_bg_img: string;
  default_img: string;
}

export const PromotionItem: FC<IProps> = ({promotion, default_bg_img, default_img}) => {
  const {t} = useTranslation();

  return (
    <>
      <Flex position="relative" justifyContent="center" alignItems="center">
        <ImageUI
          h="100%"
          objectFit="cover"
          src={`${promotion.img_for_list_thumbnail ?? default_bg_img}`}
          borderLeftRadius="16px"
          alt={promotion.name}
        />
        {!promotion.img_for_list_thumbnail && <ImageUI position="absolute" left="30px" src={default_img} />}
      </Flex>
      <Flex w="75%" flexDirection="column" p={['5px', '7px']}>
        <Text
          as="span"
          fontSize={['14px', '18px']}
          fontWeight="bold"
          color={colors.pink}
          lineHeight={['14px', '17px']}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          h={['15px', '25px']}
        >
          {promotion.name}
        </Text>
        <Text
          as="span"
          fontSize={['12px', '14px']}
          fontWeight={500}
          color={colors.textGray}
          lineHeight={['17px', '20px']}
          overflow="hidden"
          textOverflow="ellipsis"
          noOfLines={3}
        >
          {promotion.details}
        </Text>
        {promotion.promo_code_requirement ? (
          <Flex align="center" pt={['5px', '7px']}>
            <Text>{t('promoCode')}</Text>
            <SpacerUI size="sm" mode="horizontal" />
            <Flex
              as="button"
              px={3}
              py={1}
              borderRadius="md"
              bg={colors.pink}
              color="white"
              fontWeight={600}
              fontSize={['12px', '14px']}
              lineHeight={['17px', '20px']}
              cursor="pointer"
              border="none"
              minW="fit-content"
            >
              {promotion.promo_code_requirement}
            </Flex>
          </Flex>
        ) : null}
      </Flex>
    </>
  );
};
